module.exports = __webpack_public_path__ + "static/img/1958_09_19_Cologne_Program_1.7d1a571.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1958_09_19_Cologne_Program_1.jpg
// module id = Xveo
// module chunks = 0